// extracted by mini-css-extract-plugin
export default {"root":"DefaultNavItem_root__7VWis","root--disabled":"DefaultNavItem_root--disabled__D0jFC","text":"DefaultNavItem_text__c1T6O"};